import { Box, Popover, Typography } from "@material-ui/core"
import { chartStyles, drillDownStyles } from "../../../../styles"
import React from "react"
import { css, cx } from "@emotion/css"
const Icon = ({ color }: { color?: string }) => {
  return (
    <div
      className={chartStyles.line}
      style={{
        backgroundColor: color,
      }}
    >
      <div
        className={chartStyles.circle}
        style={{
          backgroundColor: color,
        }}
      ></div>
    </div>
  )
}
export function LegendItemLayout({
  title,
  color,
  selectAll,
}: {
  title: string
  color?: string
  selectAll: boolean
}) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box display="flex" alignItems={"center"} style={{ gap: "8px" }}>
      {!selectAll && (
        <div>
          <Icon color={color}></Icon>
        </div>
      )}

      <div
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        color="primary"
        className={drillDownStyles.truncateText}
      >
        <Typography align="left" className={drillDownStyles.item}>
          {title}
        </Typography>
      </div>
      {open && title.length > 22 ? (
        <Popover
          open={open}
          anchorEl={anchorEl}
          elevation={0}
          PaperProps={{
            onMouseEnter: handlePopoverOpen,
            onMouseLeave: handlePopoverClose,
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          className={styles.popover}
          classes={{ paper: styles.paper }}
        >
          <div className={styles.tooltip}>
            <span className={cx("BodyBody-2BlackRegular", styles.colored)}>
              {title}
            </span>
          </div>
        </Popover>
      ) : null}
    </Box>
  )
}
const styles = {
  paper: css`
    pointer-events: auto;
    border-radius: 0;
  `,
  popover: css`
    pointer-events: none;
  `,
  tooltip: css`
    padding: 2px;
    padding-left: 6px;
    padding-right: 6px;
    border-radius: 4px;
  `,
  colored: css`
    color: var(--dark-grey-2);
  `,
}
